module.exports = __webpack_public_path__ + "static/media/Code Of Ethics .19653ec3.pdf";